import {defineStore} from "pinia";
import {ref} from "vue";

export const useCookieStore = defineStore('cookie', () => {
  const isActive = ref<boolean>(true)

  return {
    isActive
  }
}, {
  persist: true
})
